import { variables } from "../variables";
import Axios from "axios"

export default {
    state: {
        application: [],
        beneficiaries: [],
        documents: [],
        recomendations: [null, null, null, null],
        checks: [],
        app: {
            "id": "",
            "createdAt": "",
            "updatedAt": "",
            "address": null,
            "laborData": {},
            "billingInformation": null,
            "name": "",
            "lastName": "",
            "mothersLastName": "",
            "birthDate": "",
            "birthPlace": "",
            "personalMail": "",
            "maritalStatus": "",
            "exSpouseFullName": null,
            "investigationResultMessage": null,
            "correcting": false,
            "user": {},
            "application": {
                "createdAt":"",
                "comments":[]
            },
            "documents": [],
            "phones": [],
            "beneficiaries": [],
            "cars": [],
            "recommendations": [],
            "investigations": []
        },
        titularAccordion: false,
        conyugeAccordion: false,
        beneficiariosAccordion: false,
        titularAddress: null,
        billAddress: null,
        spouseAddress: [],
        beneficiaresAddress: [],
        ListOfStatus: null,
    },
    getters: {
        getList: (state) => {
            return state.ListOfStatus
        },
        getApplication: (state) => {
            return state.application;
        },
        getApp: (state) => {
            return state.app;
        },
        getBeneficiariesData: (state) => {
            return state.beneficiaries;
        },
        getDocuments: (state) => {
            return state.documents;
        },
        getRecomendations: (state) => {
            return state.recomendations;
        },
        getChecks: (state) => {
            return state.checks;
        },
        getTitular: (state) => {
            return state.titularAccordion
        },
        getConyuge: (state) => {
            return state.conyugeAccordion
        },
        getBeneficiaries: (state) => {
            return state.beneficiariosAccordion
        },
        getAddressT: (state) => {
            return state.titularAddress
        },
        getAddressBenef: (state) => {
            return state.beneficiaresAddress
        },
        getAddressSpouse: (state) => {
            return state.spouseAddress
        },
        getAddressBill: (state) => {
            return state.billAddress
        },
    },
    mutations: {
        setApplicationData(state, header) {
            state.application = header.application;
            state.beneficiaries = header.beneficiaries
            state.documents = header.documents;
        },
        CleanApplicationData(state) {
            state.application = [];
            state.beneficiaries = [];
            state.documents = [];
            state.app = null
        },
        setApp(state, header) {
            state.app = header;
        },
        cleanApp(state) {
            state.app = null;
        },
        setRecomendations(state, header) {
            state.recomendations = header.recommendations.map(function (item) {
                return item.comments
            })

        },
        setChecks(state, header) {
            state.checks = header.recommendations.map(function (item) {
                return item.hasBeenRecommended
            })
        },
        setTitular(state, header) {
            state.titularAccordion = header;
        },
        setConyuge(state, header) {
            state.conyugeAccordion = header
        },
        setBeneficiaries(state, header) {
            state.beneficiariosAccordion = header;
        },
        setAddressT(state, header) {
            state.titularAddress = header
        },
        setAddressBill(state, header) {
            state.billAddress = header
        },
        setAddressBenef(state, header) {
            state.beneficiaresAddress = header
        },
        setSpouseAddress(state, header) {
            return state.spouseAddress = header

        },
        setList(state, header) {
            state.ListOfStatus = header
        }

    },
    actions: {
        async getListOfApplications(context, params) {
            let response = await context.rootGetters.api.get(variables.serverUrl + '/api/v1/applications?clubCode=' + params.clubCode + '&pageNumber=' + params.pageNumber + '&pageSize=' + params.pageSize + '&search=' + params.search);
            return response

        },
        async postDataSpouse(context, body) {
            let response = await Axios.post(variables.serverUrl + "/api/v1/beneficiaries", body, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('access_token')
                }
            })
            return response;
        },
        async getSingleApplication(context, params) {
            let response = await context.rootGetters.api.get(variables.serverUrl + '/api/v1/applications/' + params);
            //console.log(response.data.data)
            context.commit("setApp", response.data.data)
            context.commit("setChecks", response.data.data)
            context.commit("setRecomendations", response.data.data)
            return response;
        },
        async setAppInRevision(context, data) {
            let response = await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/applications/${data.id}/in-review-partner-service`, {});
            return response;
        },
        async checkRecommend(context, data) {
            let response = await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/applications/${data.id}/verify-recommendations`, data.body);
            return response;
        },
        async setAppInComite(context, data) {
            let response = await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/applications/${data.id}/send-committee`, {});
            return response;
        },
        async saveCommentsToComite(context, data) {
            let response = await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/applications/${data.id}/save-comment`, data.body);
            return response;
        },
        async saveNotes(context, data) {
            return await context.rootGetters.api.put(`${variables.serverUrl}/api/v1/applications/${data.id}/save-notes`, data.body);
        },
        async emitirVoto(context, data) {
            let response = await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/applications/${data.id}/vote/${data.vote}`, {});
            return response;
        },
        async sendEmailtoApplicant(context, data) {
            let response = await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/applications/${data.id}/send-response-applicant`, {});
            return response;
        },
        async obtainAddress(context, id) {
            let response = await context.rootGetters.api.get(`${variables.serverUrl}/api/v1/locations/${id}/specific`)
            context.commit("setAddressT", response.data.data)
            return response
        },
        async obtainAddressBeneficiaries(context, id) {
            let response = await context.rootGetters.api.get(`${variables.serverUrl}/api/v1/locations/${id}/specific`)
            return response.data.data
        },
        async obtainAddressBill(context, id) {
            let response = await context.rootGetters.api.get(`${variables.serverUrl}/api/v1/locations/${id}/specific`)
            context.commit("setAddressBill", response.data.data)
            return response
        },
        async downloadDocuments(context, params) {
            const requestConfig = {
                method: 'get',
                url: `${variables.serverUrl}/api/v1/applications/download-documents`,
                responseType: 'arraybuffer',
                params
            };
            return await context.rootGetters.api.request(requestConfig);
        },
        async sendInvestigationExtra(context, data) {
            let response = await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/investigations/applicant/${data.id}/extra-investigation/`, data.body);
            return response;

        },
        async sendConInvestigationExtra(context, data) {
            let response = await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/investigations/beneficiary/${data.id}/extra-investigation/`, data.body);
            return response;

        },
        async sendApplicationToUpdate(context, data) {
            return await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/applications/data-to-edit/`, data);
        },
        async finishApp(context, id) {
            return await context.rootGetters.api.put(`${variables.serverUrl}/api/v1/applications/${id}/finish-application/`, {});
        },
        async getListOfStatus(context) {
            let response = await context.rootGetters.api.get(`${variables.serverUrl}/api/v1/applications/status`)
            return response.data.data
        },
        async getStatusHistory(context, id) {
            let response = await context.rootGetters.api.get(`${variables.serverUrl}/api/v1/applications/${id}/status-history`);
            return response.data;
        }
    }
}